import React from 'react'
import styles from "./VerticalSeparator.styles"

const VerticalSeparator = ({ style = {} }) => {
    return (
        <>
            <div style={{ ...styles.divider, ...style }}></div>
        </>
    )
}

export default VerticalSeparator